"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.egressApiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
function egressApiClient(networkClient) {
    return {
        addEgressRequest: async (body) => {
            return networkClient.postHttp(data_lib_1.INTERACTIONS_WEB_SERVICE, "/api/v2/interactions/egress", body);
        },
    };
}
exports.egressApiClient = egressApiClient;
